type CarouselConfig = {
  /** Height in pixels of each slide image in the carousel. */
  slideImageHeight: number
  /** Width in pixels of each slide image in the carousel. */
  slideImageWidth: number
  /** Height in pixels of each slide image when displayed in fullscreen mode. */
  slideImageFullscreenHeight: number
  /** Width in pixels of each slide image when displayed in fullscreen mode. */
  slideImageFullscreenWidth: number
  /** Height in pixels of each slide image when displayed in fullscreen mode on mobile. */
  slideImageMobileFullscreenHeight: number
  /** Width in pixels of each slide image when displayed in fullscreen mode on mobile. */
  slideImageMobileFullscreenWidth: number
  /** Height in pixels of each pagination thumbnail image. */
  paginationImageHeight: number
  /** Width in pixels of each pagination thumbnail image. */
  paginationImageWidth: number
  /** Maximum number of slides visible at once in the carousel. */
  slidesToShow: number
}

export const CAROUSEL_CONFIG: CarouselConfig = {
  slideImageHeight: 320,
  slideImageWidth: 400,
  slideImageFullscreenHeight: 640,
  slideImageFullscreenWidth: 800,
  slideImageMobileFullscreenHeight: 400,
  slideImageMobileFullscreenWidth: 800,
  paginationImageHeight: 48,
  paginationImageWidth: 48,
  slidesToShow: 7,
} as const
